/**
 * Hook für Live-Preiskalkulation
 */

import { useState, useMemo, useCallback } from 'react';
import type { CalculatorInput, CalculatorResult, PlatformId } from '@/types/price-calculator';
import { calculatePricing, DEFAULT_INPUT, PLATFORM_PRESETS } from '@/lib/price-calculator';

export function usePriceCalculation() {
  const [input, setInput] = useState<CalculatorInput>(DEFAULT_INPUT);

  const result: CalculatorResult = useMemo(() => calculatePricing(input), [input]);

  const updateField = useCallback(<K extends keyof CalculatorInput>(
    field: K,
    value: CalculatorInput[K]
  ) => {
    setInput((prev) => ({ ...prev, [field]: value }));
  }, []);

  const setPlatform = useCallback((platformId: PlatformId) => {
    const preset = PLATFORM_PRESETS[platformId];
    setInput((prev) => ({
      ...prev,
      platformId,
      useFBA: preset.hasFBA ? prev.useFBA : false,
      customCommission: preset.commissionPercent,
      customFixedFee: preset.fixedFee,
    }));
  }, []);

  const reset = useCallback(() => setInput(DEFAULT_INPUT), []);

  return { input, result, updateField, setPlatform, reset };
}
